import {
    Chip,
    IconButton,
    MenuItem,
    Select,
    Switch,
    TableCell,
    TableRow,
    Tooltip,
    Typography,
} from "@mui/material";
import { formatPermissions, getRoleColor, roleWithPermissions } from "./utils";

import DeleteIcon from "@mui/icons-material/Delete";
import { MODEL_PROPTYPES } from "../../models";
import PropTypes from "prop-types";

export function UserRoleRow({
    userRole,
    roles,
    changes,
    onChange,
    onDelete,
    disabled,
}) {
    const roleUuid = changes.roleUuid ?? userRole.roleUuid;
    const autoGrantAccess = changes.autoGrantAccess ?? userRole.autoGrantAccess;
    const role = roles.find((r) => r.uuid === roleUuid) ?? userRole.Role;

    return (
        <TableRow>
            <TableCell>
                <Typography variant="body2" fontWeight="bold">
                    {userRole.User?.firstName} {userRole.User?.lastName}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    {userRole.User?.email}
                </Typography>
            </TableCell>
            <TableCell>
                <Select
                    size="small"
                    // Select warns on values missing from its options
                    value={roles.length ? roleUuid : ""}
                    onChange={(e) => onChange("roleUuid", e.target.value)}
                    renderValue={() =>
                        role && (
                            <Chip
                                label={role.name}
                                size="small"
                                color={getRoleColor(role.name)}
                            />
                        )
                    }
                    displayEmpty
                    sx={{ minWidth: 180 }}
                >
                    {roles.map((r) => (
                        <MenuItem key={r.uuid} value={r.uuid}>
                            {r.name}
                        </MenuItem>
                    ))}
                </Select>
            </TableCell>
            <TableCell>
                <Typography variant="caption" color="text.secondary">
                    {formatPermissions(role?.Permissions) || "—"}
                </Typography>
            </TableCell>
            <TableCell align="center">
                <Switch
                    checked={autoGrantAccess}
                    onChange={(e) =>
                        onChange("autoGrantAccess", e.target.checked)
                    }
                    size="small"
                    color="primary"
                />
            </TableCell>
            <TableCell align="right">
                <Tooltip title="Delete">
                    <span>
                        <IconButton
                            aria-label="delete"
                            size="small"
                            onClick={onDelete}
                            color="error"
                            disabled={disabled}
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </span>
                </Tooltip>
            </TableCell>
        </TableRow>
    );
}

UserRoleRow.propTypes = {
    userRole: PropTypes.shape(MODEL_PROPTYPES.UserRole).isRequired,
    roles: PropTypes.arrayOf(roleWithPermissions).isRequired,
    changes: PropTypes.shape({
        roleUuid: PropTypes.string,
        autoGrantAccess: PropTypes.bool,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};
